// extracted by mini-css-extract-plugin
module.exports = {"item":"FilterSelect_item__TcZn0"};